Moderation.Views ||= {}

class Moderation.Views.StatsView extends Backbone.View
  template: JST["backbone/templates/moderation/stats"]
  className: 'moderation-stats'

  events:
    'click .toggle-account-totals': 'onClickShowTotals'

  initialize: (@options = {}) ->
    @stats = @options.stats
    @totalsAreVisible = false

  render: (mustShowTotals = false) =>
    @totalsAreVisible = mustShowTotals
    @$el.html(@template(@))
    @showTotals() if mustShowTotals
    return this

  getTotalModeratedToday: ->
    @stats.total_moderated_today

  getTotalsPerAccount: ->
    @stats.total_per_account

  onClickShowTotals: ->
    if @totalsAreVisible
      @hideTotals()
      @$el.find('.toggle-account-totals').html("Show totals by account")
    else
      @showTotals()
      @$el.find('.toggle-account-totals').html("Hide totals by account")

  hideTotals: ->
    @$el.find('.moderation-per-account').css("visibility", "hidden")
    @totalsAreVisible = false
    @trigger('totalsHidden')

  showTotals: ->
    @$el.find('.moderation-per-account').css("visibility", "visible")
    @totalsAreVisible = true
    @trigger('totalsShown')

  getTotalsAreVisible: ->
    @totalsAreVisible
